export interface User {
  userId: string;
  email: string;
  familyId: string;
  role: UserRole;
  firstName: string;
  lastName: string;
  avatar?: string;
  createdAt: string;
  updatedAt: string;
  token?: string;
}

export enum UserRole {
  PARENT = "PARENT",
  CHILD = "CHILD",
  TEACHER = "TEACHER",
  COACH = "COACH",
}

export enum RecurrenceType {
  NONE = "NONE",
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
}

export interface RecurrenceRule {
  type: RecurrenceType;
  interval: number; // How often it repeats (every X days/weeks/months)
  endDate?: string; // Optional end date for the recurrence
  dayOfWeek?: number; // 0-6 for weekly recurrence (0 = Sunday)
  dayOfMonth?: number; // 1-31 for monthly recurrence
}

export interface Activity {
  activityId: string;
  familyId: string;
  userId: string;
  category: ActivityCategory;
  title: string;
  description: string;
  status: ActivityStatus;
  points: number; // Deprecated: kept for backward compatibility
  rewardType: RewardType; // POINTS or MONEY
  rewardAmount: number; // Amount in points or dollars
  dueDate?: string;
  completedDate?: string;
  createdAt: string;
  updatedAt: string;
  recurrence?: RecurrenceRule;
  parentActivityId?: string; // For instances of recurring activities
}

export enum ActivityCategory {
  CHORE = "CHORE",
  ATHLETIC = "ATHLETIC",
  FINANCIAL = "FINANCIAL",
  CUSTOM = "CUSTOM",
}

export enum ActivityStatus {
  PENDING = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  VERIFIED = "VERIFIED",
  CANCELLED = "CANCELLED",
}

export enum RewardType {
  POINTS = "POINTS",
  MONEY = "MONEY",
}

export interface Family {
  familyId: string;
  name: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  members: User[];
  weekStartDay?: number; // 0-6 for Sunday-Saturday, defaults to 1 (Monday)
}

// Re-export alert types
export * from "./alert";
